import React, { Component } from 'react';
import { withRouter }       from 'react-router';
import { connect }          from 'react-redux';
import { Input, Alert }     from 'reactstrap';
import { ClipLoader }       from 'react-spinners';
import { TestConstants }    from '../environment';
import { resetFetchData }   from '../../../../actions/test-maintenance/reset';

var apiHost = TestConstants.WebApiHost;

class ResetUser extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      search : '',
    };
    
    this.search         = this.search.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  
  componentDidMount() {
    this.props.fetchDataReset(apiHost, null, true);
  }
  
  search() {
    if (this.state.search.length > 1) {
      this.setState({ message: '' }, function() {
        this.props.fetchDataReset(apiHost, { Key: this.state.search });
      });
    }
  }
   
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.search();
    }
  }
  
  updateSearch(event) {
    this.setState({ search: event.target.value.toLowerCase() });
  }

  render() {
    return (
      <div style={{ marginBottom: '20px' }}>
        { this.props.resetHasErrored ?
          <Alert color='danger' style={{ opacity: 'inherit' }}>
            There was an error finding the requested user or the user is untouchable
          </Alert>
          :
          <span></span>
        }
        <div>
          <a href="https://services.dev.boisestate.edu/password/reset">Access New Password Reset Tool</a>
        </div>
        <div style={{marginTop: '10px'}}>
          { this.props.resetIsLoading ?
              <ClipLoader
                color={'#072659'} 
                loading={this.props.resetIsLoading} 
              />
              : <span />
          }
        </div>
        { this.props.reset && this.props.reset.Password ?
          <div style={{marginTop: '10px'}}>
            <p>
              <b>Common Name</b>&nbsp;<span>{this.props.reset.UserName}</span>
            </p>
            <p>
              <b>Employee ID</b>&nbsp;<span>{this.props.reset.Id}</span>
            </p>
            <p>
              <b>Expiration</b>&nbsp;<span>{this.props.reset.Expiration}</span>
            </p>
            <p>
              <b>Password</b>
              <button style={{marginLeft: '5px'}} className='c-btn c-btn--sm' onClick={() => {navigator.clipboard.writeText(this.props.reset.Password)}}>
                <span className="c-btn__text">Copy to Clipboard</span>
              </button>
            </p>
          </div>
          :
          <div></div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    reset: state.testM.reset.reset,
    resetHasErrored: state.testM.reset.resetHasErrored,
    resetIsLoading: state.testM.reset.resetIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataReset: (host, params, reset) => dispatch(resetFetchData(host, params, reset))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetUser));
